export default __webpack_public_path__ + "static/media/background.29afec01.svg";